<template>
  <li
      v-if="canViewVerticalNavMenuLink(item)"
      class="nav-item"
      :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
        v-bind="linkProps"
        class="d-flex align-items-center"
    >
      <!--Icon-->
      <i :class="item.icon" v-if="item.iconType === 'font-awesome'"></i>
      <feather-icon v-else :icon="item.icon || 'CircleIcon'" />
      <!--End Icon-->
      <span class="menu-title text-truncate">{{ $t(`menu.${item.title}`) }}</span>
      <b-badge
          v-if="tagValue"
          pill
          :variant="item.tagVariant || 'primary'"
          class="mr-1 ml-auto"
      >
        {{ tagValue }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { computed } from '@vue/composition-api'
import store from '@/store'
import { BBadge, BLink } from 'bootstrap-vue'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed:{

  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const canViewVerticalNavMenuLink = (item) => {
      if (item.meta) {
        if (item.meta.resource) {
          return this.$can(item.meta.resource, item.meta.action)
        }
      }
      return true
    }

    const tagValue = computed(() => {
      if (!props.item || !props.item.tag) return null
      if(typeof props.item.tag === 'function') return props.item.tag()
      let val = store.getters[props.item.tag] ?? null
      return !isNaN(val) && val > 0 ? val > 99 ? '99+' : val : null
    })


    return {
      tagValue,
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,
    }
  },

}
</script>
